import { compose, split, zipObject } from 'lodash/fp';
import hash from 'object-hash';
import { OccupancyData } from '@mews-commander/data-access';
import { DATE_RANGE_KEY_SEPARATOR } from '../constants';

const HASH_OPTIONS = { unorderedArrays: true };

export interface HashingParams {
    startDate: string;
    endDate: string;
    startTime: string | null;
    endTime: string | null;
    categoryId: string;
    occupancyData: Record<string, OccupancyData>;
    purpose: string | null;
    businessSegmentId: string | null;
    voucherId: string | null;
    partnerCompanyId: string | null;
    travelAgencyId: string | null;
    productIds: Array<string>;
    rateId?: string;
    channelNumber?: string | null;
    customNightCost?: $TSFixMe;
}

export const getCustomPriceKey = ({ categoryId, rateId }: $TSFixMe = {}) => hash({ categoryId, rateId }, HASH_OPTIONS);

export const createDateRangeKey = ({ startDate, endDate, startTime, endTime }: $TSFixMe) =>
    startTime && endTime
        ? `${startDate}${DATE_RANGE_KEY_SEPARATOR}${endDate}${DATE_RANGE_KEY_SEPARATOR}${startTime}${DATE_RANGE_KEY_SEPARATOR}${endTime}`
        : `${startDate}${DATE_RANGE_KEY_SEPARATOR}${endDate}`;
export const getDateRangeFromKey = compose(
    zipObject(['startDate', 'endDate', 'startTime', 'endTime']),
    split(DATE_RANGE_KEY_SEPARATOR)
);

export const getPricingKey = ({
    startDate,
    endDate,
    startTime,
    endTime,
    categoryId,
    occupancyData,
    purpose,
    businessSegmentId,
    voucherId,
    partnerCompanyId,
    travelAgencyId,
    productIds,
}: HashingParams) =>
    getReservationKey({
        startDate,
        endDate,
        startTime,
        endTime,
        categoryId,
        occupancyData,
        purpose,
        businessSegmentId,
        voucherId,
        partnerCompanyId,
        travelAgencyId,
        productIds,
    });

export const getReservationKey = ({
    startDate,
    endDate,
    startTime = null,
    endTime = null,
    categoryId,
    occupancyData,
    rateId,
    purpose = null,
    businessSegmentId = null,
    voucherId = null,
    partnerCompanyId = null,
    travelAgencyId = null,
    channelNumber = null,
    productIds = [],
    customNightCost = null,
}: HashingParams) =>
    hash(
        {
            startDate,
            endDate,
            startTime,
            endTime,
            categoryId,
            occupancyData,
            purpose,
            businessSegmentId,
            voucherId,
            partnerCompanyId,
            travelAgencyId,
            channelNumber,
            productIds,
            rateId,
            customNightCost,
        },
        HASH_OPTIONS
    );
